var map = {
	"./doc.png": "2570",
	"./doc1.png": "66ef",
	"./docx.png": "e29e",
	"./docx1.png": "0ba6",
	"./file.png": "757e",
	"./img.png": "cd14",
	"./pdf.png": "3263",
	"./pdf1.png": "76f4",
	"./xls.png": "2038",
	"./xls1.png": "ed03",
	"./xlsx.png": "31c9",
	"./xlsx1.png": "422c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b17c";